export default __webpack_public_path__ + "static/media/sonia_ribeiro.4ce6690e.webp";